/* E-Liquids mega-menu finder — makes the 3-step band interactive.
 * Single-select per step; the "View Recommendation" CTA stays disabled (grey)
 * until BOTH steps are chosen, then points at the landing page with the picks
 * as ?pfq1=<value>&pfq2=<value> (the product-finder-quiz auto-selects them). */
(function () {
  function initFinder(finder) {
    if (finder.dataset.elqBound) return;
    finder.dataset.elqBound = '1';

    var chosen = { '1': null, '2': null };
    var cta = finder.querySelector('[data-elq-cta]');
    var base = cta ? (cta.getAttribute('data-base-url') || '') : '';

    function refresh() {
      if (!cta) return;
      if (chosen['1'] && chosen['2']) {
        var sep = base.indexOf('?') > -1 ? '&' : '?';
        cta.setAttribute('href', base + sep + 'pfq1=' + encodeURIComponent(chosen['1']) + '&pfq2=' + encodeURIComponent(chosen['2']));
        cta.classList.remove('elq__finder-btn--disabled');
        cta.removeAttribute('aria-disabled');
      } else {
        cta.setAttribute('href', '#');
        cta.classList.add('elq__finder-btn--disabled');
        cta.setAttribute('aria-disabled', 'true');
      }
    }

    finder.querySelectorAll('[data-elq-opt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.getAttribute('data-step');
        var val = btn.getAttribute('data-value') || '';
        var wasSelected = btn.classList.contains('is-selected');
        finder.querySelectorAll('[data-elq-opt][data-step="' + step + '"]').forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        if (wasSelected) {
          chosen[step] = null; // clicking the active option clears it
        } else {
          chosen[step] = val;
          btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', 'true');
        }
        refresh();
      });
    });

    if (cta) {
      cta.addEventListener('click', function (e) {
        if (cta.getAttribute('aria-disabled') === 'true') e.preventDefault();
      });
    }
    refresh();
  }

  // Mobile/tablet drawer finder: two <select> dropdowns + a CTA. The button is
  // enabled once both are chosen, then navigates to the landing page with
  // ?pfq1=<device>&pfq2=<flavour> (the quiz auto-selects them).
  function initElqmFinder(finder) {
    if (finder.dataset.elqmBound) return;
    finder.dataset.elqmBound = '1';
    var base = finder.getAttribute('data-base-url') || '';
    var s1 = finder.querySelector('[data-elqm="1"]');
    var s2 = finder.querySelector('[data-elqm="2"]');
    var btn = finder.querySelector('[data-elqm-go]');
    function refresh() { if (btn) btn.disabled = !(s1 && s1.value && s2 && s2.value); }
    if (s1) s1.addEventListener('change', refresh);
    if (s2) s2.addEventListener('change', refresh);
    if (btn) btn.addEventListener('click', function () {
      if (!s1 || !s2 || !s1.value || !s2.value) return;
      var sep = base.indexOf('?') > -1 ? '&' : '?';
      window.location.href = base + sep + 'pfq1=' + encodeURIComponent(s1.value) + '&pfq2=' + encodeURIComponent(s2.value);
    });
    refresh();
  }

  function boot() {
    document.querySelectorAll('.elq__finder').forEach(initFinder);
    document.querySelectorAll('[data-elqm-finder]').forEach(initElqmFinder);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
